(function() {
  const registerAutoScroll = () => {
    if (typeof window === 'undefined') return;
    const carousalSlider = document.querySelector('[id^="custom-carousel-"]');
    if (!carousalSlider) return;
    const S = window.Splide || window.splide || self?.Splide;
    if (!S) return;
    const AutoScrollExt =
      (window.splide && window.splide.Extensions && window.splide.Extensions.AutoScroll) ||
      (window.Splide && window.Splide.Extensions && window.Splide.Extensions.AutoScroll) ||
      (typeof AutoScroll !== 'undefined' && AutoScroll) ||
      (window.AutoScroll) ||
      (self && self.AutoScroll);
    if (!AutoScrollExt) return;
    S.Extensions = S.Extensions || {};
    S.Components = S.Components || {};
    if (!S.Extensions.AutoScroll) {
      S.Extensions.AutoScroll = AutoScrollExt;
      S.Components.AutoScroll = AutoScrollExt;
    }
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', registerAutoScroll);
  } else {
    registerAutoScroll();
  }
})();